import { CombinedDocumentsMap, ReusableLayoutsMap } from 'models';
import { isReusableLayoutDocument } from './entityType';
import { filterCombinedDocuments } from './filterCombinedDocuments';

export const filterReusableLayouts = (documents: CombinedDocumentsMap): ReusableLayoutsMap => {
  return filterCombinedDocuments(documents, isReusableLayoutDocument) as ReusableLayoutsMap;
};
